export function FinancialAccountsTopbar() {
  return <></>;
}
